import _PersonIcon from "@adsk/alloy-react-icon/es/lib/PersonIcon";
import _PersonFilledIcon from "@adsk/alloy-react-icon/es/lib/PersonFilledIcon";
import React from 'react';
import PropTypes from 'prop-types';
import { variantSwitch } from '@adsk/alloy-react-helpers';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import Avatar from '../Avatar';
const renderPersonFilledIcon = p => /*#__PURE__*/React.createElement(_PersonFilledIcon, p);
const renderPersonIcon = p => /*#__PURE__*/React.createElement(_PersonIcon, p);
function getIconBySize(size) {
  return size === Avatar.SIZES.SMALL_16 || size === Avatar.SIZES.MEDIUM_24 ? renderPersonFilledIcon : renderPersonIcon;
}
const DefaultAvatar = _ref => {
  let {
    style,
    className,
    size = Avatar.SIZES.MEDIUM_32
  } = _ref;
  return /*#__PURE__*/React.createElement(Avatar, {
    className: className,
    size: size,
    style: [{
      color: theme.tokens.colors.icon.tertiary.value,
      backgroundColor: theme.tokens.colors.background.accent.six.subtler.value
    }, style]
  }, getIconBySize(size)({
    size: variantSwitch({
      statement: size,
      variants: {
        [Avatar.SIZES.SMALL_16]: 10,
        [Avatar.SIZES.MEDIUM_24]: 15,
        [Avatar.SIZES.MEDIUM_32]: 25,
        [Avatar.SIZES.LARGE_48]: 40,
        [Avatar.SIZES.XLARGE_64]: 50,
        [Avatar.SIZES.XXLARGE_128]: 100
      }
    }) || undefined
  }));
};
DefaultAvatar.SIZES = Avatar.SIZES;
DefaultAvatar.displayName = 'DefaultAvatar';
DefaultAvatar.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Set the size of the avatar */
  size: PropTypes.oneOf(Object.values(Avatar.SIZES))
};
export default Object.assign(DefaultAvatar, {
  SIZES: Avatar.SIZES
});
//# sourceMappingURL=DefaultAvatar.js.map